export interface AvatarOption {
  value: string
  label: string
}

export interface AvatarCategory {
  key: string
  label: string
  options: AvatarOption[]
}

export const AVATAR_CATEGORIES: AvatarCategory[] = [
  {
    key: 'gender',
    label: 'Gênero',
    options: [
      { value: 'Male', label: 'Masculino' },
      { value: 'Female', label: 'Feminino' },
      { value: 'Robot', label: 'Robô' },
    ],
  },
  {
    key: 'skinTone',
    label: 'Tom de Pele',
    options: [
      { value: 'Light', label: 'Claro' },
      { value: 'Medium', label: 'Médio' },
      { value: 'Tan', label: 'Bronzeado' },
      { value: 'Brown', label: 'Moreno' },
      { value: 'Dark Brown', label: 'Marrom Escuro' },
      { value: 'Deep Dark', label: 'Muito Escuro' },
      { value: 'Metallic/Chrome', label: 'Metálico' },
      { value: 'Blue', label: 'Azul' },
      { value: 'Green', label: 'Verde' },
      { value: 'Pink', label: 'Rosa' },
    ],
  },
  {
    key: 'hairStyle',
    label: 'Estilo de Cabelo',
    options: [
      { value: 'Buzzcut', label: 'Raspado' },
      { value: 'Short Cropped', label: 'Curto' },
      { value: 'Messy/Spiky', label: 'Bagunçado' },
      { value: 'Side Part', label: 'Repartido' },
      { value: 'Wavy Medium', label: 'Ondulado Médio' },
      { value: 'Long Flowing', label: 'Longo Solto' },
      { value: 'Curly/Afro', label: 'Cacheado/Afro' },
      { value: 'Updo/Bun', label: 'Coque' },
      { value: 'Slicked Back', label: 'Penteado p/ Trás' },
      { value: 'Bald', label: 'Careca' },
    ],
  },
  {
    key: 'hairColor',
    label: 'Cor do Cabelo',
    options: [
      { value: 'Black', label: 'Preto' },
      { value: 'Dark Brown', label: 'Castanho Escuro' },
      { value: 'Light Brown', label: 'Castanho Claro' },
      { value: 'Blonde', label: 'Loiro' },
      { value: 'Red/Ginger', label: 'Ruivo' },
      { value: 'Gray/Silver', label: 'Grisalho/Prata' },
      { value: 'Purple', label: 'Roxo' },
      { value: 'Blue', label: 'Azul' },
    ],
  },
  {
    key: 'facialHair',
    label: 'Barba',
    options: [
      { value: 'None', label: 'Nenhuma' },
      { value: 'Stubble', label: 'Barba por Fazer' },
      { value: 'Short Beard', label: 'Barba Curta' },
      { value: 'Full Beard', label: 'Barba Cheia' },
      { value: 'Mustache', label: 'Bigode' },
      { value: 'Goatee', label: 'Cavanhaque' },
    ],
  },
  {
    key: 'eyeColor',
    label: 'Cor dos Olhos',
    options: [
      { value: 'Brown', label: 'Castanho' },
      { value: 'Blue', label: 'Azul' },
      { value: 'Green', label: 'Verde' },
      { value: 'Hazel', label: 'Avelã' },
      { value: 'Gray', label: 'Cinza' },
    ],
  },
  {
    key: 'expression',
    label: 'Expressão',
    options: [
      { value: 'Friendly Smile', label: 'Sorriso Amigável' },
      { value: 'Serious', label: 'Sério' },
      { value: 'Confident Smirk', label: 'Sorriso Confiante' },
      { value: 'Warm Grin', label: 'Sorriso Caloroso' },
      { value: 'Thoughtful', label: 'Pensativo' },
      { value: 'Playful Wink', label: 'Piscadela' },
    ],
  },
  {
    key: 'glasses',
    label: 'Óculos',
    options: [
      { value: 'None', label: 'Nenhum' },
      { value: 'Square Frames', label: 'Armação Quadrada' },
      { value: 'Round Frames', label: 'Armação Redonda' },
      { value: 'Aviator Frames', label: 'Aviador' },
      { value: 'Cat-Eye Frames', label: 'Gatinho' },
      { value: 'Thick Retro Frames', label: 'Retrô Grosso' },
      { value: 'Rimless Glasses', label: 'Sem Armação' },
      { value: 'Sunglasses', label: 'Óculos de Sol' },
    ],
  },
  {
    key: 'clothing',
    label: 'Roupa',
    options: [
      { value: 'T-Shirt', label: 'Camiseta' },
      { value: 'Hoodie', label: 'Moletom' },
      { value: 'Polo Shirt', label: 'Polo' },
      { value: 'Blazer', label: 'Blazer' },
      { value: 'Dress Shirt', label: 'Camisa Social' },
      { value: 'Vest', label: 'Colete' },
      { value: 'Sweater', label: 'Suéter' },
      { value: 'Turtleneck', label: 'Gola Alta' },
    ],
  },
  {
    key: 'headgear',
    label: 'Chapéu / Capacete',
    options: [
      { value: 'None', label: 'Nenhum' },
      { value: 'Flat Cap', label: 'Boina' },
      { value: 'Beanie', label: 'Gorro' },
      { value: 'Headband', label: 'Faixa de Cabeça' },
      { value: 'Baseball Cap', label: 'Boné' },
      { value: 'Bucket Hat', label: 'Bucket Hat' },
      { value: 'Top Hat', label: 'Cartola' },
      { value: 'Over-Ear Headphones', label: 'Fones de Ouvido' },
    ],
  },
  {
    key: 'accessories',
    label: 'Acessórios',
    options: [
      { value: 'None', label: 'Nenhum' },
      { value: 'Earrings', label: 'Brincos' },
      { value: 'Necklace', label: 'Colar' },
      { value: 'Bow Tie', label: 'Gravata Borboleta' },
      { value: 'Scarf', label: 'Cachecol' },
      { value: 'Necktie', label: 'Gravata' },
      { value: 'Lanyard with Badge', label: 'Crachá' },
      { value: 'Corded Earbuds', label: 'Fones com Fio' },
    ],
  },
]

export type AvatarSelections = Record<string, string>

// Constraint constants
const FANTASY_SKIN_TONES = ['Metallic/Chrome', 'Blue', 'Green', 'Pink']
const FANTASY_HAIR_COLORS = ['Purple', 'Blue']
const ROBOT_EYE_OPTIONS: AvatarOption[] = [
  { value: 'Glowing Red', label: 'Vermelho Brilhante' },
  { value: 'Glowing Blue', label: 'Azul Brilhante' },
]

const categoriesByKey = Object.fromEntries(AVATAR_CATEGORIES.map((c) => [c.key, c]))

/** Returns filtered options for a category based on current selections */
export function getConstrainedOptions(categoryKey: string, selections: AvatarSelections): AvatarOption[] {
  const category = categoriesByKey[categoryKey]
  if (!category) return []

  const gender = selections.gender
  const baseOptions = category.options

  switch (categoryKey) {
    case 'facialHair':
      if (gender === 'Female' || gender === 'Robot') {
        return baseOptions.filter((o) => o.value === 'None')
      }
      return baseOptions

    case 'skinTone':
      if (gender === 'Male' || gender === 'Female') {
        return baseOptions.filter((o) => !FANTASY_SKIN_TONES.includes(o.value))
      }
      return baseOptions

    case 'hairColor':
      if (gender === 'Male' || gender === 'Female') {
        return baseOptions.filter((o) => !FANTASY_HAIR_COLORS.includes(o.value))
      }
      return baseOptions

    case 'eyeColor':
      if (gender === 'Robot') {
        return [...baseOptions, ...ROBOT_EYE_OPTIONS]
      }
      return baseOptions

    case 'accessories':
      if (selections.headgear === 'Over-Ear Headphones') {
        return baseOptions.filter((o) => o.value !== 'Corded Earbuds')
      }
      return baseOptions

    case 'headgear':
      if (selections.accessories === 'Corded Earbuds') {
        return baseOptions.filter((o) => o.value !== 'Over-Ear Headphones')
      }
      return baseOptions

    default:
      return baseOptions
  }
}

/** Sanitize selections so every value is valid for current constraints */
export function sanitizeSelections(selections: AvatarSelections): AvatarSelections {
  const result = { ...selections }

  // Force facial hair to None for Female/Robot
  if (result.gender === 'Female' || result.gender === 'Robot') {
    result.facialHair = 'None'
  }

  // Robot defaults to Bald if no hair style set
  if (result.gender === 'Robot' && !result.hairStyle) {
    result.hairStyle = 'Bald'
  }

  // Bald disables hair color
  if (result.hairStyle === 'Bald') {
    delete result.hairColor
  }

  // Sunglasses disables eye color
  if (result.glasses === 'Sunglasses') {
    delete result.eyeColor
  }

  // Validate each category's current value against constrained options
  for (const category of AVATAR_CATEGORIES) {
    const key = category.key
    if (!(key in result)) continue

    const validOptions = getConstrainedOptions(key, result)
    const currentValue = result[key]

    if (!validOptions.some((o) => o.value === currentValue)) {
      result[key] = validOptions[0]?.value ?? ''
    }
  }

  return result
}

/** Generate random selections respecting all constraint rules */
export function randomizeConstrainedSelections(): AvatarSelections {
  const result: AvatarSelections = {}

  // Pick gender first — it drives most constraints
  const genderCategory = categoriesByKey['gender']
  result.gender = genderCategory.options[Math.floor(Math.random() * genderCategory.options.length)].value

  // Pick remaining categories using constrained options
  for (const category of AVATAR_CATEGORIES) {
    if (category.key === 'gender') continue

    const options = getConstrainedOptions(category.key, result)
    result[category.key] = options[Math.floor(Math.random() * options.length)].value
  }

  // Robot defaults to Bald
  if (result.gender === 'Robot') {
    result.hairStyle = 'Bald'
  }

  return sanitizeSelections(result)
}

export function buildPromptFromSelections(selections: AvatarSelections): string {
  const parts: string[] = []

  if (selections.gender) {
    if (selections.gender === 'Robot') {
      parts.push('A humanoid robot character with a metallic/synthetic appearance')
    } else {
      parts.push(`A ${selections.gender.toLowerCase()} character`)
    }
  }
  if (selections.skinTone) parts.push(`${selections.skinTone} skin tone`)
  if (selections.hairStyle && selections.hairStyle !== 'Bald') {
    const color = selections.hairColor ? ` in ${selections.hairColor}` : ''
    parts.push(`${selections.hairStyle} hairstyle${color}`)
  } else if (selections.hairStyle === 'Bald') {
    parts.push('Bald head')
  }
  if (selections.facialHair && selections.facialHair !== 'None') {
    parts.push(`${selections.facialHair} facial hair`)
  } else if (selections.facialHair === 'None') {
    parts.push('No facial hair')
  }
  if (selections.eyeColor) parts.push(`${selections.eyeColor} eyes`)
  if (selections.expression) parts.push(`${selections.expression} expression`)
  if (selections.glasses && selections.glasses !== 'None') {
    parts.push(`Wearing ${selections.glasses} glasses`)
  }
  if (selections.clothing) {
    parts.push(`Wearing a ${selections.clothing}`)
  }
  if (selections.headgear && selections.headgear !== 'None') {
    parts.push(`Wearing a ${selections.headgear} on head`)
  }
  if (selections.accessories && selections.accessories !== 'None') {
    parts.push(`${selections.accessories} as accessory`)
  }

  return parts.join('. ')
}
